module.exports = __webpack_public_path__ + "img/nissan.41758212.svg";